import React from 'react';
import { ContentSection, Spinner } from '@vwfs-bronson/bronson-react';

export const SpinnerSection = () => {
  return (
    <ContentSection pageWrap className="u-m-xlarge">
      <Spinner section />
    </ContentSection>
  );
};
